export const queryNames = {
  All_HOUSE_BY: "All_HOUSE_BY",
  ALL_BUILDING_BY: "ALL_BUILDING_BY",
  FLAT_DATA_BY: "FLAT_DATA_BY",
  BLOCK_STATISTIC: "BLOCK_STATISTIC",
  BLOCK_FLOOR_STATISTIC: "BLOCK_FLOOR_STATISTIC",
  BLOCK_FLAT_DATA: "BLOCK_FLAT_DATA",
  GET_ALL_HOUSE: "GET_ALL_HOUSE",
};
